import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getServices = (): Promise<ISelectModel<number>[]> => {
  return API.get('/api/root/services/all').then(res => res?.data);
};
